var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[(_vm.state)?_c('oc-icon',{staticClass:"checked-icon",attrs:{"type":"check"}}):_c('oc-icon',{staticClass:"unchecked-icon",attrs:{"type":"times"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }